import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "21",
  viewBox: "0 0 18 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9 13.8V15.8M3 19.8H15C16.1046 19.8 17 18.9046 17 17.8V11.8C17 10.6955 16.1046 9.80005 15 9.80005H3C1.89543 9.80005 1 10.6955 1 11.8V17.8C1 18.9046 1.89543 19.8 3 19.8ZM13 9.80005V5.80005C13 3.59091 11.2091 1.80005 9 1.80005C6.79086 1.80005 5 3.59091 5 5.80005V9.80005H13Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }